import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PrepareTextService } from '../../service/prepare-text.service';
import { ClipboardService } from 'ngx-clipboard';
import { GoogleAnalysticsService } from 'src/app/shared/service/google-analystics.service';
import { MailInfo } from 'src/app/shared/model/mail-info.model';
import { MailerComponent } from '../component/mailer/mailer.component';

@Component({
  selector: 'app-detail-email-reply',
  templateUrl: './detail-email-reply.component.html',
  styleUrls: ['./detail-email-reply.component.scss']
})
export class DetailEmailReplyComponent implements OnInit, OnDestroy {
  @Input() mailInfo: MailInfo;
  @Input() isReply: boolean;
  @Input() mailType: string;

  @Input() mailSubject: string;
  @Input() mailTo: string;
  @Input() mailBody: string;
  @Input() mailCc: string;
  mailHref: string;

  constructor(
    public modalService: NgbModal,
    private toastrService: ToastrService,
    private clipboardService: ClipboardService,
    private googleAnalysticsService: GoogleAnalysticsService,
    private prepareTextService: PrepareTextService
  ) {}

  ngOnInit() {
    this.refreshParams();
  }

  ngOnDestroy() {}

  refreshParams() {
    if (this.mailInfo) {
      // メーラーに入れる件名と送信先を変数に代入と
      // メーラ起動用リンク作成
      this.mailSubject = this.isReply ? 'Re:' + this.mailInfo.msg_subj : 'Re:' + this.mailInfo.title;
      this.mailTo = this.isReply ? this.mailInfo.msg_from : this.mailInfo.mail_from;
      this.mailBody = this.isReply ? this.mailInfo.msg_body : this.mailInfo.body;
      this.mailCc = this.mailInfo.mail_cc;
    }
    this.mailHref = `mailto:${this.mailTo}?subject=${this.mailSubject}${this.mailCc ? `&cc=${this.mailCc}` : ''}`;
  }

  sendMail() {
    this.request();
  }

  request() {
    this.refreshParams();
    if (this.mailInfo) {
      this.googleAnalysticsService.eventEmit(
        '問い合わせメール',
        this.mailType === 'project' ? this.mailInfo.ai_mail_id : '---',
        this.mailType === 'worker' ? this.mailInfo.ai_mail_id : '---',
        0
      );
    }
    this.mailBody = this.prepareTextService.setReplyMailText(this.mailBody);
    this.openModal();
    this.copyToClipboard(this.mailBody);
  }

  // 引数に渡された文字列をクリップボードにコピー
  private copyToClipboard(body: string): void {
    this.clipboardService.copyFromContent(body);

    this.toastrService.success('クリップボードにメールの本文をコピーしました');
  }

  openModal() {
    const modalRef = this.modalService.open(MailerComponent);
    modalRef.componentInstance.mailHref = this.mailHref;
    modalRef.componentInstance.mailTo = this.mailTo;
    modalRef.componentInstance.mailSubject = this.mailSubject;
    modalRef.componentInstance.mailCc = this.mailCc;
  }
}
